// Generador del Informe ARPSI (Riesgo de Inundación) — devuelve el HTML
// completo listo para abrirse en una pestaña emergente. Extraído de
// OperationalIROs.js para poder invocarlo desde Informes Técnicos.

export function generateArpsiHtml({ project, settings }) {
  const lat = Number(settings?.latitude)
  const lon = Number(settings?.longitude)
  const status = settings?.arpsi_status || 'not_checked'
  const statusLabel = ({
    not_at_risk:  'ACTIVO NO EN RIESGO',
    at_risk_T10:  'RIESGO ALTO (T=10 años)',
    at_risk_T100: 'RIESGO MEDIO (T=100 años)',
    at_risk_T500: 'RIESGO BAJO (T=500 años)',
    not_checked:  'PENDIENTE DE VERIFICAR',
  })[status] || status
  const statusColor = status === 'not_at_risk' ? '#8D9A2E' : status === 'not_checked' ? '#7A6A5A' : '#C98A2E'
  const today = new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })
  const projName = (project?.name || 'Proyecto sin nombre').replace(/</g, '&lt;')
  const address  = (settings?.address || (isFinite(lat) && isFinite(lon) ? `${lat.toFixed(5)}, ${lon.toFixed(5)}` : 'Sin dirección registrada')).replace(/</g, '&lt;')
  const checkDate = settings?.arpsi_check_date || '(sin fecha)'
  const src = (settings?.arpsi_source || 'Sin cita registrada').replace(/</g, '&lt;')

  return `<!DOCTYPE html>
<html lang="es"><head><meta charset="utf-8">
<title>Informe ARPSI · ${projName}</title>
<link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css" integrity="sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=" crossorigin="" />
<script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js" integrity="sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=" crossorigin=""></script>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'DM Sans', -apple-system, system-ui, sans-serif; color: #2C2017; background: #FFFFFF; padding: 32px 48px; line-height: 1.5; }
  .noprint { position: sticky; top: 0; background: #F5F0EA; border: 1px solid #DDD5C8; border-radius: 6px; padding: 10px 14px; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center; z-index: 10; }
  .noprint button { background: #8D9A2E; color: white; border: none; padding: 8px 14px; border-radius: 4px; font-size: 13px; cursor: pointer; font-weight: 600; }
  h1 { font-size: 22px; margin-bottom: 4px; }
  h2 { font-size: 14px; text-transform: uppercase; letter-spacing: 0.05em; color: #7A6A5A; margin-top: 24px; margin-bottom: 8px; border-bottom: 1px solid #DDD5C8; padding-bottom: 4px; }
  h3 { font-size: 13px; margin-top: 12px; color: #2C2017; }
  p, li { font-size: 12.5px; margin-bottom: 6px; }
  .header { border-bottom: 3px solid #3B2F2F; padding-bottom: 14px; margin-bottom: 20px; }
  .header .sub { color: #7A6A5A; font-size: 12px; letter-spacing: 0.04em; }
  .status-box { background: ${statusColor}18; border: 2px solid ${statusColor}; border-radius: 6px; padding: 16px 20px; margin: 18px 0; page-break-inside: avoid; break-inside: avoid; }
  .status-box .label { font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: #7A6A5A; }
  .status-box .value { font-size: 20px; font-weight: 700; color: ${statusColor}; margin-top: 4px; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 6px; }
  th, td { text-align: left; padding: 6px 8px; border-bottom: 1px solid #EDE7DE; }
  th { background: #F5F0EA; color: #5C4A3A; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.03em; }
  #map { width: 100%; height: 420px; border: 1px solid #DDD5C8; border-radius: 4px; margin-top: 8px; }
  .quote { background: #FAF7F3; border-left: 3px solid #8D9A2E; padding: 10px 14px; margin-top: 6px; font-style: italic; font-size: 11.5px; color: #2C2017; }
  .footer { margin-top: 32px; padding-top: 14px; border-top: 1px solid #DDD5C8; color: #7A6A5A; font-size: 10.5px; }
  .legend-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 8px; }
  .legend-block { display: grid; grid-template-columns: 100px 1fr; gap: 8px; padding: 8px 10px; border: 1px solid #EDE7DE; border-radius: 4px; background: #FDFAF6; page-break-inside: avoid; break-inside: avoid; }
  .legend-block .lg-title { font-size: 11px; font-weight: 600; color: #2C2017; margin-bottom: 2px; }
  .legend-block .lg-note { font-size: 10px; color: #7A6A5A; line-height: 1.35; }
  .legend-wide { display: grid; grid-template-columns: 260px 1fr; gap: 14px; padding: 10px 12px; border: 1px solid #EDE7DE; border-radius: 4px; background: #FDFAF6; margin-top: 8px; page-break-inside: avoid; break-inside: avoid; align-items: center; }
  .legend-wide img { max-width: 260px; max-height: 220px; background: #FFF; border: 1px solid #EDE7DE; padding: 4px; }
  .legend-wide .lg-title { font-size: 12px; font-weight: 600; color: #2C2017; margin-bottom: 4px; }
  .legend-wide .lg-note { font-size: 11px; color: #4A4A4A; line-height: 1.5; }
  @media print {
    .noprint { display: none !important; }
    body { padding: 18mm; }
    #map { break-inside: avoid; page-break-inside: avoid; }
    h2 { break-after: avoid-page; page-break-after: avoid; }
    h3 { break-after: avoid-page; page-break-after: avoid; }
    .legend-grid { break-inside: avoid; page-break-inside: avoid; }
    .legend-block { break-inside: avoid; page-break-inside: avoid; }
    .legend-wide { break-inside: avoid; page-break-inside: avoid; }
  }
</style></head>
<body>
  <div class="noprint">
    <span style="font-size:12px;color:#5C4A3A"><strong>Vista previa del informe.</strong> Espera unos segundos a que cargue el mapa y luego pulsa el botón de la derecha.</span>
    <button onclick="window.print()">Imprimir · Guardar como PDF</button>
  </div>
  <div class="header">
    <div class="sub">Informe técnico · BREEAM-Analyzer · Consultoría HAUS Healthy Buildings</div>
    <h1>Análisis de Riesgo de Inundación (ARPSI)</h1>
    <div style="font-size:12px;color:#5C4A3A;margin-top:6px">Directiva 2007/60/CE · Real Decreto 903/2010 · Sistema Nacional de Cartografía de Zonas Inundables (SNCZI) — MITECO</div>
  </div>

  <div class="status-box">
    <div class="label">Resultado de la verificación</div>
    <div class="value">${statusLabel}</div>
    <div style="font-size:11px;color:#7A6A5A;margin-top:6px">Comprobado el ${checkDate} contra el servicio WMS oficial del SNCZI.</div>
  </div>

  <h2>1. Datos del activo</h2>
  <table>
    <tr><th style="width:35%">Proyecto</th><td>${projName}</td></tr>
    <tr><th>Dirección</th><td>${address}</td></tr>
    <tr><th>Coordenadas WGS84</th><td>${isFinite(lat) ? lat.toFixed(6) : '—'} · ${isFinite(lon) ? lon.toFixed(6) : '—'}</td></tr>
  </table>

  <h2>2. Marco normativo aplicable</h2>
  <ul style="padding-left:20px">
    <li><strong>Directiva 2007/60/CE</strong> del Parlamento Europeo, relativa a la evaluación y gestión de los riesgos de inundación.</li>
    <li><strong>Real Decreto 903/2010</strong>, transposición al ordenamiento español, define los ARPSI (Áreas con Riesgo Potencial Significativo de Inundación).</li>
    <li><strong>ESRS E1-9</strong> (CSRD) — reporting de riesgos físicos climáticos agudos.</li>
  </ul>

  <h2>3. Cartografía consultada</h2>
  <div id="map"></div>
  <p style="font-size:10.5px;color:#7A6A5A;margin-top:6px">Base cartográfica: OpenStreetMap. Capas ARPSI oficiales: MITECO SNCZI (WMS <code>servicios.idee.es/wms-inspire/riesgos-naturales/inundaciones</code>). El marcador indica la ubicación del activo. Las capas fluviales (T=10, T=100, T=500 años) y marinas se pueden alternar desde el control superior derecho.</p>

  <h3>3.1 · Leyenda de las capas ARPSI</h3>
  <div class="legend-grid">
    <div class="legend-block">
      <div>
        <div class="lg-title">Fluvial T=10 · Prob. alta</div>
        <div class="lg-note">Cada 10 años · 10 %/año. Zona de flujo preferente. Restringida para nueva edificación por RD 903/2010.</div>
      </div>
      <div>
        <div class="lg-title">Fluvial T=100 · Prob. media</div>
        <div class="lg-note">Cada 100 años · 1 %/año. Umbral crítico art. 14 RD 903/2010. Aplican medidas de mitigación.</div>
      </div>
    </div>
    <div class="legend-block">
      <div>
        <div class="lg-title">Fluvial T=500 · Prob. baja</div>
        <div class="lg-note">Cada 500 años · 0,2 %/año. Escenario extremo — informativa para planificación.</div>
      </div>
      <div>
        <div class="lg-title">Marina T=100 / T=500</div>
        <div class="lg-note">Origen marino · sobreelevación y oleaje. Solo activos costeros. Contempla cambio climático.</div>
      </div>
    </div>
  </div>

  <div class="legend-wide">
    <img src="https://servicios.idee.es/wms-inspire/riesgos-naturales/inundaciones?service=WMS&request=GetLegendGraphic&format=image/png&layer=NZ.Flood.FluvialT500&sld_version=1.1.0" alt="Leyenda inundaciones T=500" />
    <div>
      <div class="lg-title">Leyenda oficial MITECO SNCZI · Inundaciones fluviales</div>
      <div class="lg-note">Franjas de color usadas por el servicio WMS oficial del Ministerio para la Transición Ecológica. La escala se aplica igual para T=10, T=100 y T=500; cambia únicamente el periodo de retorno considerado.</div>
    </div>
  </div>

  <p style="font-size:10px;color:#B0A89E;margin-top:6px;font-style:italic">Leyenda obtenida en vivo del servicio WMS oficial mediante el estándar OGC GetLegendGraphic.</p>

  <h2>4. Detalle técnico de la consulta</h2>
  <div class="quote">${src}</div>

  <h2>5. Conclusión</h2>
  ${status === 'not_at_risk' ? `
    <p>El activo <strong>NO está clasificado</strong> en ninguna de las capas ARPSI oficiales del SNCZI (fluvial T=10, T=100, T=500 y marinas T=100, T=500). Este resultado se considera <strong>evidencia auditable</strong> para el bloque ESRS E1-9 de la memoria CSRD, y respalda la no aplicación del detector D11 (Riesgo Físico Agudo) del catálogo IRO operativo del edificio.</p>
    <p style="margin-top:6px">Los ARPSI se revisan en ciclos EPRI de 6 años. Esta verificación deberá repetirse tras la próxima actualización oficial del SNCZI.</p>
  ` : `
    <p>El activo <strong>SÍ está clasificado</strong> en un Área con Riesgo Potencial Significativo de Inundación. Se recomienda incorporar al plan de mitigación medidas físicas específicas (protecciones perimetrales, elevación de equipos críticos, red de drenaje adicional) y evaluar la contratación de un seguro específico de daños por inundación.</p>
  `}

  <div class="footer">
    Documento generado automáticamente el ${today} por BREEAM-Analyzer sobre datos oficiales del MITECO SNCZI (Directiva 2007/60/CE). Este informe es de apoyo técnico; no sustituye a la comprobación oficial del SNCZI que se puede realizar en <a href="https://sig.miteco.gob.es/snczi/">sig.miteco.gob.es/snczi</a>.
  </div>

<script>
  window.addEventListener('load', () => {
    setTimeout(() => {
      const lat = ${isFinite(lat) ? lat : 'null'}, lon = ${isFinite(lon) ? lon : 'null'};
      if (!lat || !lon) return;
      const map = L.map('map', { scrollWheelZoom: false }).setView([lat, lon], 15);
      // Esri World Light Gray Canvas (free + uso comercial con atribución, sin key)
      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', { maxZoom: 16, attribution: 'Tiles © Esri' }).addTo(map);
      const wms = 'https://servicios.idee.es/wms-inspire/riesgos-naturales/inundaciones';
      const wmsOpts = { format: 'image/png', transparent: true, version: '1.3.0', attribution: 'MITECO SNCZI' };
      const layers = {
        'Fluvial T=10':  L.tileLayer.wms(wms, { ...wmsOpts, layers: 'NZ.Flood.FluvialT10',  opacity: 0.6 }),
        'Fluvial T=100': L.tileLayer.wms(wms, { ...wmsOpts, layers: 'NZ.Flood.FluvialT100', opacity: 0.5 }),
        'Fluvial T=500': L.tileLayer.wms(wms, { ...wmsOpts, layers: 'NZ.Flood.FluvialT500', opacity: 0.4 }),
        'Marina T=100':  L.tileLayer.wms(wms, { ...wmsOpts, layers: 'NZ.Flood.MarinaT100',  opacity: 0.5 }),
        'Marina T=500':  L.tileLayer.wms(wms, { ...wmsOpts, layers: 'NZ.Flood.MarinaT500',  opacity: 0.4 }),
      };
      layers['Fluvial T=100'].addTo(map);
      L.control.layers({}, layers, { collapsed: false, position: 'topright' }).addTo(map);
      L.marker([lat, lon]).addTo(map).bindPopup('${projName.replace(/'/g,"\\'")}').openPopup();
      L.control.scale({ imperial: false }).addTo(map);
    }, 200);
  });
</script>
</body></html>`
}
